/* eslint-disable no-var */
/* eslint-env node */

var DayPickerInput = require('./lib/src/DayPickerInput');

module.exports = DayPickerInput.default || DayPickerInput;



/*****************
 ** WEBPACK FOOTER
 ** ./~/react-day-picker/DayPickerInput.js
 ** module id = 2512
 ** module chunks = 50
 **/